import { combineReducers } from 'redux'
import misc from './misc'
import vacations from './vacations'

export default combineReducers({
  misc,
  vacations,
})
